import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import GroupingNavMenu from './GroupingNavMenu';

function AppNavButton({ icon, path, showGroupingMenu, text, variant = 'home', isUpdatedData = false, handleUnsavedData, resetState }) {
	const [menuAnchor, setMenuAnchor] = useState(null);
	const [isClose, setIsClose] = useState(false);
	const textMenuItem = text + ' Menu Item';

	function handleKeyPress(e) {
		if (e.key === "Enter")
		{
			handleButtonClick(e);
		}
	}

	function handleButtonClick(e) {
		if (isUpdatedData && !isClose) {
			const isDataToSave = handleUnsavedData ? handleUnsavedData() : false;
			if (isDataToSave) {
				e.preventDefault();
				setIsClose(true);
			}
		} else if (showGroupingMenu) {
			setIsClose(false);
			if (resetState) {
				resetState();
			}
			e.stopPropagation();
			e.preventDefault();
			setMenuAnchor(e.currentTarget);
		}
	}

	function handleLinkClick(e) {
		if (showGroupingMenu) {
			e.preventDefault();
		}
	}

	function handleMenuClose() {
		setMenuAnchor(null);
	}

	return (
		<Link
			tabIndex="-1"
			style={variant === 'home' ? { color: '#1d2a59' } : undefined}
			onClick={handleLinkClick}
			to={{
				pathname: path,
				state: { title: text }
            }}
		>
            <span tabIndex="0" role="link" aria-label={textMenuItem} className="home-menu-link" onKeyPress={handleKeyPress} onClick={handleButtonClick}>
                <span className="home-menu-icon" role="img" title={text}>{icon}</span>
                {variant === 'home' && (
                    <span className="home-menu-text">{text}</span>
                )}
			</span>
			{showGroupingMenu && <GroupingNavMenu anchorEl={menuAnchor} path={path} onClose={handleMenuClose} />}
		</Link>
	);
}

AppNavButton.propTypes = {
	icon: PropTypes.element.isRequired,
	path: PropTypes.string.isRequired,
	showGroupingMenu: PropTypes.bool,
	text: PropTypes.string.isRequired,
	variant: PropTypes.oneOf(['header', 'home']),
	isUpdatedData: PropTypes.bool,
	handleUnsavedData: PropTypes.func,
	resetState: PropTypes.func
};

export default AppNavButton;
